<template>
  <div>
    <authentication-forms-container :image="image">
      <form @submit.prevent="onSubmit" class="mt-4">
        <h4 class="mb-5 text-primary" v-t="'forget_password.title'"></h4>

        <div class="form-group mb-4 mt-3">
          <label for="cellphone" v-t="'authentication_general.email_or_cellphone'"></label>
          <input dir="ltr" v-model="form.email" type="text"
                 :placeholder="$t('authentication_general.email_or_cellphone_placeholder')"
                 class="form-control rounded-pill text-left mt-3" id="cellphone">
          <form-errors-manager :validation="v$.form.email"/>
        </div>

        <div class="my-3">
          <m-captcha1 v-model="form.captcha_answer"/>
          <form-errors-manager :validation="v$.form.captcha_answer"/>
        </div>

        <button type="submit" class="mb-4 w-100 btn btn-block btn-primary rounded-pill"
                v-t="'forget_password.button_submit'">تایید
        </button>
      </form>
    </authentication-forms-container>
  </div>
</template>

<script>
import {useVuelidate} from '@vuelidate/core'
import {email, maxLength, minLength, or, required} from "@vuelidate/validators";
import {phone} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/VuelidateCustomValidatoins";
import FormErrorsManager from "../../validator/FormErrorsManager";
import AuthenticationFormsContainer from "../Form/AuthFormsContainer";
import mCaptcha1 from "../../Captcha/Captcha1";
import {captchaValidation} from "../../Captcha/CaptchaValidation";

export default {
  name: "ForgetPassword1",
  components: {FormErrorsManager, AuthenticationFormsContainer, mCaptcha1},
  setup() {
    return {v$: useVuelidate()}
  },
  data() {
    return {
      form: {
        email: "",
        captcha_answer: '',
      },
    };
  },
  props: {
    image: {
      type: String,
      default: null
    }
  },
  validations() {
    return {
      form: {
        email: {required, emailOrPhone: phone},
        captcha_answer: captchaValidation,
      },
    }
  },
  methods: {
    async onSubmit() {

      const result = await this.v$.form.$validate()
      if (!result) return

      if (phone(this.form.email)) {
        const f = {cellphone: this.form.email};
        this.$store.dispatch("Authentication/cellphoneForgetPassword", f);
      } else {
        this.$store.dispatch("Authentication/emailForgetPassword", this.form);
      }

    },
  },
};
</script>
<style scoped>

</style>